import axios from "../utilities/api-axios"

const apiUrl = process.env.REACT_APP_API_URL;

export class StateService {
    getStatesIdDescription(start) {
        return axios.get(`${apiUrl}/states/IdDescription/` + start).then((res) => res.data);
    }
}
